import { z } from 'zod'

export const AGENT_GATEWAY_EXCEPTIONS_CONTRACT_VERSION = '1.0.0' as const

const passthroughResponseSchema = z.object({}).passthrough()

export const agentGatewayHealthResponseSchema = passthroughResponseSchema
export const agentGatewaySubmitResponseSchema = passthroughResponseSchema

export type AgentGatewayHealthResponse = z.infer<typeof agentGatewayHealthResponseSchema>
export type AgentGatewaySubmitResponse = z.infer<typeof agentGatewaySubmitResponseSchema>
